<div class="component-container">
  <div class="left">
    <!-- <div class="logo">
      <div [routerLink]="[linkHome]"><img [alt]="'HEADER_LOGO_TEXT' | translate" [src]="'logo.scv'" /></div>
    </div> -->
    <div class="mixtures">
      <a [routerLink]="[linkMixtures]">
        <app-button
          [label]="'HEADER_MIXTURES'"
          [isLink]="true"
          [size]="activeTab === NavTabsEnum.Mixtures ? 'large' : undefined"
          (buttonClicked)="onTabChanged(NavTabsEnum.Mixtures)"
        ></app-button>
      </a>
    </div>
    <div class="materials">
      <a [routerLink]="[linkMaterials]"
        ><app-button
          [label]="'HEADER_MATERIALS'"
          [isLink]="true"
          [size]="activeTab === NavTabsEnum.Materials ? 'large' : undefined"
          (buttonClicked)="onTabChanged(NavTabsEnum.Materials)"
        ></app-button
      ></a>
    </div>
  </div>
  <div class="right">
    <div class="login">
      <app-button [icon]="'pi pi-user'" [raised]="true" [rounded]="true" (buttonClicked)="signIn()"></app-button>
    </div>
  </div>
</div>
